import {useState} from 'react'

export const useProductButtonContainer = () => {
  const formInitialData = {
    productTemplateName: '',
    storeSelector: '',
    actions: '',
    numberOfDays: '',
    numberOfPoints: '',
    schedule: '',
    startDate: '',
    endDate: '',
  }

  const [isModal, toggleModal] = useState(false)
  const [formData, setFormData] = useState({...formInitialData})

  return {isModal, toggleModal, setFormData, formData}
}
